import styled, { css } from 'styled-components';

export const Background = styled.div<{ $src: string | undefined }>(
  ({ theme, $src }) => css`
    height: 100%;
    ${
      $src
        ? css`
            background-image:
              linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('${$src}');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
          `
        : css`
            background-color: ${theme.co.neutral60};
          `
    }
  `,
);
